import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-toggle-switch",
  templateUrl: "./toggle-switch.component.html",
  styleUrls: ["./toggle-switch.component.css"],
})
export class ToggleSwitchComponent {
  isChecked: boolean = true;

  constructor(private router: Router) {}

  toggleSwitch() {
    this.isChecked = !this.isChecked;
    if (this.isChecked) {
      window.location.href = "https://redapp.wigal.com.gh/login"; // Navigate to the live app
    } else {
      this.router.navigate(["login"]); // Navigate to t demo login
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/toggle-switch/toggle-switch.component.ts